import Magazine from './src/magazine'
import Book from './src/book'
import Audio from './src/audio'
import Video from './src/video'
import User from './src/user'
import PageConfig from './src/pageConfig'
import ShortQC from './src/shortQC'
import Newspaper from './src/newspaper'
import ArticleLibrary from './src/articlelibrary'
import Advertisement from './src/advertisement'
const services = {
    magazine: new Magazine({ serviceName: 'magazine' }),
    book: new Book({ serviceName: 'book' }),
    audio: new Audio({ serviceName: 'audio' }),
    video: new Video({ serviceName: 'video' }),
    user: new User({ serviceName: 'user' }),
    pageConfig: new PageConfig({ serviceName: 'pageConfig' }),
    shortQC: new ShortQC({ serviceName: 'shortQC' }),
    newspaper:new Newspaper({serviceName: 'newspaper'}),
    articleLibrary:new ArticleLibrary({serviceName: 'articleLibrary'}),
    advertisement:new Advertisement({serviceName: 'advertisement'})
}
export default services
